import React from 'react';
import { LoadScript } from '@react-google-maps/api';

const { VITE_FLEET_MAP_API_KEY } = import.meta.env;

const libraries: 'places'[] = ['places'];

const MapLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<LoadScript
			googleMapsApiKey={VITE_FLEET_MAP_API_KEY as string}
			libraries={libraries}
		>
			{children}
		</LoadScript>
	);
};

export default MapLoader;
